import { User } from '@auth0/auth0-react';

export const userIsBroker = (user?: User) => {
  return user?.['http://focus-solutions.net/roles']?.includes('Broker');
};

export const userIsAdmin = (user?: User) => {
  return user?.['http://focus-solutions.net/roles']?.includes('Administrator');
};

export const userHasReferralAccess = (user?: User) => {
  return user?.['http://focus-solutions.net/user_metadata']
    ?.can_access_referrals;
};

export const userHasApiAccess = (user?: User) => {
  // Hardcoded client codes that have API access
  const allowedClientCodes = ['ZFA'];

  const userClientCodes =
    user?.['http://focus-solutions.net/user_metadata']?.client_code;

  if (!userClientCodes) return false;

  const clientCodeArray = Array.isArray(userClientCodes)
    ? userClientCodes
    : [userClientCodes];

  return clientCodeArray.some((code) => allowedClientCodes.includes(code));
};
